import { useEffect } from 'react';
import { ScanCommand, PutItemCommand } from '@aws-sdk/client-dynamodb';
import { marshall, unmarshall } from '@aws-sdk/util-dynamodb';
import {v4 as uuidv4} from 'uuid';
import { 
        Text, 
        Select, 
        Button,
        Switch,
        FormControl,
        FormLabel,
        Link
    } from '@chakra-ui/react';



    function EditorBoardSelector(props) {
     
    const { setBoard, boardList, setBoardList, setEditorMode, editorMode, client, definitionTable, signOut } = props;
    const handleSelect = (selectedBoardID) => {
        setBoard(selectedBoardID);  
    };
    
    const createNewItem = async (newItem) => {
        const marshalledItem = marshall(newItem);
        const command = new PutItemCommand({
            TableName: definitionTable,
            Item: marshalledItem
        });
        const response = await client.send(command);
        console.log(response); // or do something else with the response
        setBoard(newItem.id);
    };
     
    const handleCreate = () => {
        let newItem = {
            name: "New",
            id: uuidv4(),
            layout: [],
            widgets: [],
            theme: {
            'bgColor': '#fafafa',
            'cardColor': 'linear-gradient(145deg, #e1e1e1, #f0f0f0)',
            'fontColor': '#000000',
            },
            imgUrl: null,
        };
        createNewItem(newItem);
        
    };
    
    //scan for a list of wallboards
    useEffect(() => {
        if(client && definitionTable){
            const fetchData = async () => {
              const command = new ScanCommand({
                TableName: definitionTable,
                ProjectionExpression: 'id, #n',
                ExpressionAttributeNames: { '#n': 'name' },
              });
            
              const response = await client.send(command);
              setBoardList(response.Items.map(item => unmarshall(item)));
            };
            
            fetchData();
        }
    }, [client, definitionTable, setBoardList]);

    
    return (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'start', padding: '2em', width: '100vw', height: '100vh'}}>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start', padding: '1em', width: '100%', height: '10%' }}>
                <img alt='logo' src={process.env.PUBLIC_URL + "/images/one-nz-logo-black.png"} style={{height: '100%'}} />
            </div>
         <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'start', width: '100%', height: '90%' }}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'space-between', width: '50%', height: '50%' }}>
                <Text fontSize='5xl'> Wallboard Editor </Text>
                { boardList ?
                    <>
                        <Text fontSize='2xl'> Select a board to edit or create a new one</Text>
                        <Select placeholder='Select a Board' onChange={(e) => handleSelect(e.target.value)}>
                            {boardList.map((board, itx) => {
                            return ( 
                                <option key={`slector-option-key-${itx}`} value={board.id}>{board.name}</option>
                            );
                            })}
                        </Select>
                        <Button onClick={() => handleCreate()}>Create New</Button>
                    </>
                :
                    <Text fontSize='2xl'> Fetching board list...</Text>
                }
            </div>
         </div>
         <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', minWidth: '100%'}}>
             <FormControl display='flex' alignItems='center'>
                <FormLabel htmlFor='mode' mb='0'>
                    Toggle edit mode
                </FormLabel>
              <Switch colorScheme='teal' id='mode' isChecked={editorMode} onChange={(e) => setEditorMode(e.target.checked)} />
            </FormControl>
            <Link style={{marginRight: '2em'}} onClick={signOut}> [LogOut] </Link>
        </div>
     </div>
     
    );
    
}

export default EditorBoardSelector;